import { render, staticRenderFns } from "./winery-carrier-alert-content.vue?vue&type=template&id=55e85e78&scoped=true&"
import script from "./winery-carrier-alert-content.vue?vue&type=script&lang=js&"
export * from "./winery-carrier-alert-content.vue?vue&type=script&lang=js&"
import style0 from "./winery-carrier-alert-content.vue?vue&type=style&index=0&id=55e85e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e85e78",
  null
  
)

export default component.exports